// Google parks the page on this hash for as long as its vignette ad is showing.
export const isGoogleVignetteShowing = () => window.location.hash === "#google_vignette"
